module.exports = __webpack_public_path__ + "media/images/illust/fb-bg-3af5eecae603bd910f0f36e21f24374f.jpg";